<template>
  <el-dialog
    v-if="tagData"
    title="告警設備資訊"
    :width="'70%'"
    :visible.sync="visible"
    @closed="handleClosed"
  >
    <!-- 整個表單 -->
    <div class="content-container">
      <!-- 每個欄位 -->
      <div
        v-for="[en, zh] in Object.entries(tagDetailStructure)"
        :key="en"
        class="content-wrapper"
        :class="en"
      >
        <!-- 欄位標題 -->
        <div
          class="key"
          :class="{required:zh === '處理備註'}"
        >
          {{ zh }}
        </div>
        <!-- 推播開關 -->
        <!-- 正翰表示：1 為關閉 0 為開啟 -->
        <div
          v-if="en === 'NotificationSwitch'"
          class="value switch"
        >
          {{ tagData[en] ? '關閉' : '開起' }}
        </div>
        <!-- 告警事件累計次數 -->
        <div
          v-else-if="en === 'Events' && Array.isArray(tagData[en])"
          class="value events"
        >
          {{ tagData[en].length }}
        </div>
        <div
          v-else-if="en === 'EventListByDevice'"
          class="eventListByTag"
        >
          <el-table
            :data="tagData.Events"
            style="width: 100%"
          >
            <el-table-column
              label="#"
              type="index"
              width="50"
            />
            <el-table-column
              v-for="[en,zh] in Object.entries(eventListByTagStructure)"
              :key="en"
              :prop="en"
              :label="zh"
              width="auto"
            >
              <template slot-scope="scope">
                <pre class="regular">{{ scope.row[en] }}</pre>
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
            >
              <template slot-scope="scope">
                <div class="operate">
                  <el-button
                    v-if="!scope.row.CurrentStageType.includes('結案')"
                    size="mini"
                    type="text"
                    @click="handleClickReport(scope.row.EventId)"
                  >
                    回報
                  </el-button>
                  <el-button
                    size="mini"
                    type="text"
                    @click="handleClickEventDetail(scope.row.EventId)"
                  >
                    檢視
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          v-else
          class="value regular"
          :class="{emergency:
            tagData.Status === '異常' &&
            (en === 'Status' || en === 'Value') }"
        >
          {{ Number.isInteger(tagData[en]) ? tagData[en] : tagData[en] || '-' }}
        </div>
      </div>
    </div>
    <el-button
      type="primary"
      @click="handleClose"
    >
      確定
    </el-button>
  </el-dialog>
</template>

<script>
import { tagDetailStructure, eventReportHistoryStructure, eventListByTagStructure, eventStageType } from '../models'
import { processEventList } from '../utils'
export default {
  components: {
  },
  props: {
  },
  data () {
    return {
      visible: false,
      tagData: null,
      tagDetailStructure,
      eventReportHistoryStructure,
      eventListByTagStructure
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
    openEventDetail (row) {
      if (row) {
        const tempTagData = { ...row }
        let tempEvents = [...tempTagData.Events]
        tempEvents = processEventList(tempEvents)
        tempTagData.Events = tempEvents
        this.tagData = tempTagData
        this.visible = true
      }
    },
    localUpdateTagDetail (updateRowData) {
      this.tagData.Events = this.tagData.Events.map(el => {
        if (el.EventId === updateRowData.EventId) {
          const tempEl = { ...el }
          tempEl.CurrentStageType = eventStageType[updateRowData.CurrentStageType]
          tempEl.CurrentStageRemark = updateRowData.CurrentStageRemark
          tempEl.StageList = updateRowData.StageList
          return tempEl
        }
        return el
      })
    },
    handleClose () {
      this.visible = false
    },
    handleClosed () {
      // 將資料初始化
      this.tagData = null
      // 如果從網址來的則關掉彈窗要清空路徑
      if (this.$route.nam === 'eventDetailById') {
        this.$router.push({ name: 'baEvent' })
      }
    },
    handleClickReport (row) {
      this.$emit('handleClickReport', row)
    },
    handleClickEventDetail (id) {
      this.$emit('handleClickEventDetail', id)
    }
  }
}
</script>

  <style lang="scss" scoped>
::v-deep .el-table {
  @include basicTable(true);
}
::v-deep .el-dialog {
  @include basicDialog();
  .content-container {
    display: flex;
    flex-wrap: wrap;
    .content-wrapper {
      $key_size: 17px;
      text-align: start;
      display: flex;
      min-height: 20px;
      padding-bottom: 10px;
      padding-right: 10px;
      box-sizing: border-box;
      width: 50%;
      flex: 0 0 33%;
      margin-bottom: 20px;
      line-height: calc(#{$key_size} * 1.5);
      .key {
        color: $mainFontColor;
        $key_width: 160px;
        $key_width: 110px;
        padding-right: 10px;
        flex: 0 0 $key_width;
        font-weight: bold;
        font-size: $key_size;
      }
      .value {
        flex: 0 1 100%;
        .el-dropdown-link {
          cursor: pointer;
        }
      }
      &.EventListByDevice {
        // 要佔整行
        flex: 0 0 100%;
        flex-direction: column;
        height: unset;
        width: 100%;
        padding-bottom: 30px;
        .key {
          flex: 0 0 30px;
        }
        .value {
          flex: 1 1 0%;
        }
        .operate {
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          * {
            margin: 0;
          }
        }
      }
    }
  }
}
</style>
